<template>
  <div class="container">
    <div class="formtitle">绑定企业</div>
    <div class="formbox">
      <van-form validate-first @submit="onSubmit">
        <van-field
          v-model="form.companyName"
          placeholder="请输入企业名称"
          :rules="formRules.companyName"
          class="myform"
        />
        <van-field
          v-model="form.taxNum"
          placeholder="请输入税号"
          :rules="formRules.taxNum"
          class="myform"
        />
        <div class="formbtn">
          <van-button native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      form:{
        companyName:"",
        taxNum:"",
      },
      formRules:{
        companyName:[{ required: true, message: '请输入企业名称' }],
        taxNum:[
          { required: true, message: '请输入税号' },
          { validator: this.taxNumError, message: '税号格式不正确' }
        ],
      }
    }
  },
  methods:{
    onSubmit() {
      console.log(this.form)
      let dataJson = {
        qymc:this.form.companyName,
        qysh:this.form.taxNum
      }
      this.axios.post("/system/user/bdQy",dataJson)
      .then(res=>{
        if(res.code==200){
          sessionStorage.setItem("qymc",this.form.companyName)
          sessionStorage.setItem("qysh",this.form.taxNum)
          this.$toast("绑定企业成功")
          this.$router.replace("/unbinding")
        }else{
          this.$toast(res.msg)
        }
      })
    },
    taxNumError(val){
      if(val&&(val.trim().length<15 || /[\u4E00-\u9FFF]+/.test(val))){
        return false
      }
    },
  }
}
</script>

<style src="@/assets/css/css.css" scoped></style>
<style scoped>
.van-cell{
  padding: 0.48rem 0 0.32rem;
  border-bottom: 1px solid #ededed;
  line-height:1;
  font-size: 0.3rem;
}
.myform>>>.van-field__error-message{
  position: absolute;
}
.van-button--normal{
  font-size: 0.3rem;
  font-weight: bold;
  width: 100%;
  height: 0.83rem;
  background-color: #0175f3;
  color: #fff;
  border-radius: 0.45rem;
}
</style>